<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="n in 3" :key="`line_form_2_col_${n}`">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="m in 4" :key="`line_form_2_col_${m}`">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer v-for="p in 12" :key="`spacer_${p}`" />
        <v-col class="text-right">
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
        <v-col class="text-right">
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
    </v-sheet>
    <div v-show="!showSkeleton">
      <div class="text-h4">Relatório de Ligações</div>

      <v-form class="mt-4">
        <v-row dense>
          <v-col>
            <v-datetime-picker
              label="Data início"
              v-model="datetimestart"
              :date-picker-props="dateProps"
              :time-picker-props="timeProps"
              :text-field-props="textProps"
              date-format="dd/MM/yyyy"
              time-format="HH:mm"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar-month</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock-outline</v-icon>
              </template>
              <template slot="actions" slot-scope="{ parent }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      ripple
                      outlined
                      icon
                      color="darkRed"
                      @click="cancelEvent(parent)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      ripple
                      outlined
                      icon
                      color="bluePcm"
                      @click="parent.okHandler"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Confirmar</span>
                </v-tooltip>
              </template>
            </v-datetime-picker>
          </v-col>

          <v-col>
            <v-datetime-picker
              label="Data fim"
              v-model="datetimeend"
              :date-picker-props="dateProps"
              :time-picker-props="timeProps"
              :text-field-props="textProps"
              date-format="dd/MM/yyyy"
              time-format="HH:mm"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar-month</v-icon>
              </template>

              <template slot="timeIcon">
                <v-icon>mdi-clock-outline</v-icon>
              </template>

              <template slot="actions" slot-scope="{ parent }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      ripple
                      outlined
                      icon
                      color="darkRed"
                      @click="cancelEvent(parent)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      ripple
                      outlined
                      icon
                      color="bluePcm"
                      @click="parent.okHandler"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Confirmar</span>
                </v-tooltip>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col>
            <v-autocomplete
              dense
              outlined
              label="Status"
              v-model="form.status"
              :items="status"
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.text }}</span>
                <v-chip v-if="index === 1" small>
                  <span class="caption"> (+{{ form.status.length - 1 }}) </span>
                </v-chip>
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleStatus">
                  <v-list-item-action>
                    <v-icon
                      :color="form.status.length > 0 ? 'indigo darken-4' : ''"
                    >
                      {{ iconStatus }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Selecionar Todos
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2" />
              </template>
            </v-autocomplete>
          </v-col>
          <v-col v-if="this.permissaoVisualizarProtocolo">
            <v-text-field
              dense
              outlined
              label="Protocolo"
              :value="protocol"
              @change="(v) => (protocol = v)"
            />
          </v-col>
        </v-row>
        <v-row dense>
           <v-col>
            <v-text-field
              dense
              outlined
              label="Origem"
              hint="Ex.: 7000,7001,7002-7005"
              persistent-hint
              :value="numeroOrigem"
              @change="(v) => (numeroOrigem = v)"
            />
          </v-col>
           <v-col>
            <v-text-field
              dense
              outlined
              label="Destino"
              hint="Ex.: 7000,7001,7002-7005"
              persistent-hint
              :value="numeroDestino"
              @change="(v) => (numeroDestino = v)"
            />
          </v-col>
          <v-col>
            <v-autocomplete
              dense
              outlined
              label="Tags"
              v-model="form.tags"
              :items="tags"
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.text }}</span>
                <v-chip v-if="index === 1" small>
                  <span class="caption"> (+{{ form.tags.length - 1 }}) </span>
                </v-chip>
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleTags">
                  <v-list-item-action>
                    <v-icon
                      :color="form.tags.length > 0 ? 'indigo darken-4' : ''"
                    >
                      {{ iconTags }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Selecionar Todos
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2" />
              </template>
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              dense
              outlined
              label="Ramais"
              v-model="form.ramais"
              :items="ramais"
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.text }}</span>
                <v-chip v-if="index === 1" small>
                  <span class="caption"> (+{{ form.ramais.length - 1 }}) </span>
                </v-chip>
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleRamais">
                  <v-list-item-action>
                    <v-icon
                      :color="form.ramais.length > 0 ? 'indigo darken-4' : ''"
                    >
                      {{ iconRamais }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Selecionar Todos
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2" />
              </template>
            </v-autocomplete>
          </v-col>
              
          <!-- <v-col>
            <v-select
              dense
              outlined
              label="Centros de Custo"
              v-model="form.centroDeCusto"
              :items="centroDeCusto"
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.text }}</span>
                <v-chip v-if="index === 1" small>
                  <span class="caption"> (+{{ form.centroDeCusto.length - 1 }}) </span>
                </v-chip>
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleCentroDeCusto">
                  <v-list-item-action>
                    <v-icon :color="form.centroDeCusto.length > 0 ? 'indigo darken-4' : ''">
                      {{ iconCentroDeCusto }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Selecionar Todos
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2" />
              </template>
            </v-select>
          </v-col> -->
        </v-row>
        <v-row dense>
          <v-col class="text-right">
            <v-btn color="orangePcm" dark class="mr-2" @click="exportExcel"
              >Exportar</v-btn
            >
            <v-btn color="bluePcm" @click="gerarRelatorio" dark>Gerar</v-btn>
          </v-col>
        </v-row>
      </v-form>

      <v-divider class="ma-2" />

      <v-sheet v-show="showSkeletonReportData" class="pa-3">
        <v-skeleton-loader class="mx-auto" type="table" />
      </v-sheet>
      <div v-show="showReportData && !showSkeletonReportData">
        <ExpansionPanel :panel="panel"/>

        <v-row no-gutters class="mb-14 mt-n14">
          <span class="ml-8 grey--text">
            Itens: {{ initialItem }} - {{ finalItem }} de {{ totalItems }}
          </span>
          <v-spacer />
          <div class="mr-2">
            <ListPagination
              :page="currentPage"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

import Snackbar from "@/componentes/Snackbar";
import ListPagination from "@/componentes/ListPagination";
import { registerVuexModule } from "@/utils/vuexUtils";
import { initialAndFinalDateTextInputReportForm } from "@/mixins/initialAndFinalDateTextInputReportForm";
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";

import ExpansionPanel from "../_components/ExpansionPanel";

import relatorioChamadasStore from "../_store";

import relatorioChamadasHttpService from '../_services/relatorioChamadasHttpService';

export default {
  components: { Snackbar, ExpansionPanel, ListPagination },
  mixins: [initialAndFinalDateTextInputReportForm],
  data: () => ({
    snackbar: false,
    text: "",
    form: {
      dataHoraFim: "",
      dataHoraInicio: "",
      numeroOrigem: [],
      numeroDestino: [],
      tags: [],
      ramais: [],
      status: [],
      centroDeCusto: [],
      protocol: [],
    },
    status: [
      { text: "Atendida", value: "atendida" },
      { text: "Ocupado", value: "ocupado" },
      { text: "Acesso Negado", value: "acessoNegado" },
      { text: "Não Atendida", value: "naoAtendida" },
      { text: "Erro", value: "error" },
      { text: "Outros", value: "outros" },
      { text: "Pendente", value: "pending" },
    ],
    tags: [],
    ramais: [],
    centroDeCusto: [],
    numeroOrigem: "",
    numeroDestino: "",
    protocol: "",
    currentPage: 1,
    itemsPerPage: 20,
    totalItems: 0,
    showSkeleton: true,
    showReportData: false,
    showSkeletonReportData: false,
    panel: [],
    permissaoVisualizarProtocolo:false,
  }),

  computed: {
    ...mapGetters("relatorioLigacoesModuloRelatoriosLigacoes", [
      "getTags",
      "getRamais",
      "getCentroDeCustos",
      "getDadosRelatorio",
    ]),
    numberOfPages() {
      let numberOfPages = 0;
      if (this.getDadosRelatorio.totalItems) {
        numberOfPages = Math.ceil(
          this.getDadosRelatorio.totalItems / this.itemsPerPage
        );
      }
      return numberOfPages;
    },
    initialItem() {
      return 1 + (this.currentPage - 1) * this.itemsPerPage;
    },

    finalItem() {
      let finalItem = 0;
      if (this.getDadosRelatorio.totalItems) {
        if (
          this.initialItem + (this.itemsPerPage - 1) >
          this.getDadosRelatorio.totalItems
        ) {
          finalItem = this.getDadosRelatorio.totalItems;
        } else {
          finalItem = this.initialItem + this.itemsPerPage - 1;
        }
      }

      return finalItem;
    },
    todosStatusSelecionados() {
      return this.form.status.length === this.status.length;
    },
    algunsStatusSelecionados() {
      return this.form.status.length > 0 && !this.todosStatusSelecionados;
    },
    iconStatus() {
      if (this.todosStatusSelecionados) return "mdi-close-box";
      if (this.algunsStatusSelecionados) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    todasTagsSelecionadas() {
      return this.form.tags.length === this.tags.length;
    },
    algumasTagsSelecionadas() {
      return this.form.tags.length > 0 && !this.todasTagsSelecionadas;
    },
    iconTags() {
      if (this.todasTagsSelecionadas) return "mdi-close-box";
      if (this.algumasTagsSelecionadas) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    todosRamaisSelecionados() {
      return this.form.ramais.length === this.ramais.length;
    },
    algunsRamaisSelecionados() {
      return this.form.ramais.length > 0 && !this.todosRamaisSelecionados;
    },
    iconRamais() {
      if (this.todosRamaisSelecionados) return "mdi-close-box";
      if (this.algunsRamaisSelecionados) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    todosCentrosDeCustoSelecionados() {
      return this.form.centroDeCusto.length === this.centroDeCusto.length;
    },
    algunsCentrosDeCustoSelecionados() {
      return (
        this.form.centroDeCusto.length > 0 &&
        !this.todosCentrosDeCustoSelecionados
      );
    },
    iconCentroDeCusto() {
      if (this.todosCentrosDeCustoSelecionados) return "mdi-close-box";
      if (this.algunsCentrosDeCustoSelecionados) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },

  async created() {
    this.permissaoVisualizarProtocolo = false
    registerVuexModule(
      this.$store,
      "relatorioLigacoesModuloRelatoriosLigacoes",
      relatorioChamadasStore
    );

    await Promise.all([
      this.listarTags(),
      this.listarRamais(),
      this.listarCentroDeCustos(),
      this.listarConferencias(),
    ]);

    this.tags = this.getTags.map((tag) => ({
      text: tag.description,
      value: tag._id,
    }));
    
    // this.tags.sort(function(a, b){
    //     if(a.text.toLowerCase() < b.text.toLowerCase()) { return -1; }
    //     if(a.text.toLowerCase() > b.text.toLowerCase()) { return 1; }
    //     return 0;
    // })

    this.ramais = this.getRamais.map((ramal) => ({
      text: `${ramal.numero} - ${ramal.usuario}`,
      value: ramal.numero,
    }));

    this.centroDeCusto = this.getCentroDeCustos.map((centroDeCusto) => ({
      text: `${centroDeCusto.codigo} - ${centroDeCusto.description}`,
      value: centroDeCusto._id,
    }));
    const arrayPermissions = this.arrayPermissionsFromLocalStorage();
    if (arrayPermissions.includes(process.env.VUE_APP_RELATORIO_PABX_PROTOCOLO_TOTAL)||arrayPermissions.includes(process.env.VUE_APP_ADMINISTRADOR)||arrayPermissions.includes(process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_TOTAL)) {
      this.permissaoVisualizarProtocolo = true;
    }

    this.showSkeleton = false;
  },

  methods: {

    ...obtainUserPermissions,
    ...mapActions("relatorioLigacoesModuloRelatoriosLigacoes", [
      "listarTags",
      "listarRamais",
      "listarConferencias",
      "listarCentroDeCustos",
      "gerarDadosRelatorio",
    ]),
    protocolNovo(protocolo){
      const protocol = protocolo.split(',');
      return protocol;
    },
    async gerarRelatorio() {
      this.showSkeletonReportData = true;

      const dataInicio = moment(this.datetimestart).format("YYYY-MM-DD HH:mm");
      const dataFim = moment(this.datetimeend).format("YYYY-MM-DD HH:mm");

      if (dataInicio > dataFim) {
        this.text = "Data início não pode ser maior que a data fim.";
        this.snackbar = true;
        return;
      }

      this.form.dataHoraInicio = dataInicio;
      this.form.dataHoraFim = dataFim;
      this.currentPage = 1;
      await this.gerarDadosRelatorio({
        form: this.form,
        page: this.currentPage,
      });     
      this.totalItems = this.getDadosRelatorio.totalItems;
      this.showReportData = true;
      this.showSkeletonReportData = false;
    },

    async nextPage() {
      if (this.currentPage + 1 <= this.numberOfPages) {
        this.currentPage += 1;
        this.$router.push({ query: { page: this.currentPage } }).catch(()=>{});
        this.showSkeletonReportData = true;
        await this.gerarDadosRelatorio({
          form: this.form,
          page: this.currentPage,
        });     
        this.panel = [];
        this.showReportData = true;
        this.showSkeletonReportData = false;
      }
    },
    async formerPage() {
      if (this.currentPage - 1 >= 1) {
        this.currentPage -= 1;
        this.$router.push({ query: { page: this.currentPage } }).catch(()=>{});
        this.showSkeletonReportData = true;
        await this.gerarDadosRelatorio({
          form: this.form,
          page: this.currentPage,
        });     
        this.panel = [];
        this.showReportData = true;
        this.showSkeletonReportData = false;
      }
    },
    async firstPage() {
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.$router.push({ query: { page: this.currentPage } }).catch(()=>{});
        this.showSkeletonReportData = true;
        await this.gerarDadosRelatorio({
          form: this.form,
          page: this.currentPage,
        });     
        this.panel = [];
        this.showReportData = true;
        this.showSkeletonReportData = false;
      }
    },
    async lastPage() {
      if (this.currentPage < this.numberOfPages) {
        this.currentPage = this.numberOfPages;
        this.$router.push({ query: { page: this.currentPage } }).catch(()=>{});
        this.showSkeletonReportData = true;
        await this.gerarDadosRelatorio({
          form: this.form,
          page: this.currentPage,
        });     
        this.panel = [];
        this.showReportData = true;
        this.showSkeletonReportData = false;
      }
    },

    async exportExcel() {
      const params = {
        dataHoraInicio: moment(this.datetimestart).format('YYYY-MM-DD HH:mm'),
        dataHoraFim: moment(this.datetimeend).format('YYYY-MM-DD HH:mm'),
        numeroOrigem: this.form.numeroOrigem,
        numeroDestino: this.form.numeroDestino,
        centroDeCusto: this.form.centroDeCusto,
        status: this.form.status,
        tags: this.form.tags,
        ramais: this.form.ramais,
        protocol: this.form.protocol,
      }
      // console.log(params)

      window.open(relatorioChamadasHttpService.exportExcel(params))
    },

    toggleStatus() {
      this.$nextTick(() => {
        if (this.todosStatusSelecionados) {
          this.form.status.splice(0);
        } else {
          this.form.status.splice(0);
          this.form.status = this.status.map((status) => status.value);
        }
      });
    },
    toggleTags() {
      this.$nextTick(() => {
        if (this.todasTagsSelecionadas) {
          this.form.tags.splice(0);
        } else {
          this.form.tags.splice(0);
          this.form.tags = this.tags.map((tag) => tag.value);
        }
      });
    },
    toggleRamais() {
      this.$nextTick(() => {
        if (this.todosRamaisSelecionados) {
          this.form.ramais.splice(0);
        } else {
          this.form.ramais.splice(0);
          this.form.ramais = this.ramais.map((ramal) => ramal.value);
        }
      });
    },
    toggleCentroDeCusto() {
      this.$nextTick(() => {
        if (this.todosCentrosDeCustoSelecionados) {
          this.form.centroDeCusto.splice(0);
        } else {
          this.form.centroDeCusto.splice(0);
          this.form.centroDeCusto = this.centroDeCusto.map(
            (centroDeCusto) => centroDeCusto.value
          );
        }
      });
    },
    stringDestinoToArray(numero) {
      const numeroIntermediario = numero.split(",");
      const numeroArray = [];

      numeroIntermediario.forEach((numeros) => {
        if (typeof numeros.split("-")[1] === "undefined") {
          numeroArray.push(numeros);
        } else {
          const inicioRange = numeros.split("-")[0];
          const finalRange = numeros.split("-")[1];
          if (inicioRange > finalRange) {
            window.alert(
              "Início do range não pode ser maior que final do range"
            );
            return;
          }

          for (let i = inicioRange; i <= finalRange; i++) {
            numeroArray.push(i.toString());
          }
        }
      });
      return numeroArray;
    },
  },
  watch: {
    numeroDestino(novo) {
      this.form.numeroDestino = this.stringDestinoToArray(novo);
      if (
        this.form.numeroDestino[0] === "" &&
        this.form.numeroDestino.length === 1
      )
        this.form.numeroDestino.splice(0, 1);
    },
    numeroOrigem(novo) {
      this.form.numeroOrigem = this.stringDestinoToArray(novo);
      if (
        this.form.numeroOrigem[0] === "" &&
        this.form.numeroOrigem.length === 1
      )
        this.form.numeroOrigem.splice(0, 1);
    },
    protocol(novo) {
      this.form.protocol = this.protocolNovo(novo)
      if (this.form.protocol[0] === '' && this.form.protocol.length === 1)
        this.form.protocol.splice(0, 1)
    },
  },
};
</script>
